<div class="warp-white">
    <div class="grid-header">
        <div class="flex-2" translate>column.distributionGroups.name</div>
        <div class="flex-1" translate>column.distributionGroups.createDate</div>
        <div class="flex-1 min-width-190" translate>column.distributionGroups.creator</div>
        <div class="flex-1" translate>column.distributionGroups.questionnaires</div>
        <div class="flex-1" translate>column.distributionGroups.reminders</div>
        <div class="flex-2" translate>column.distributionGroups.recipients</div>
        <div class="flex-half last"></div>
    </div>
</div>